import { Enums } from '../common/enums'

import { IJsonSerializable, IReferenceType } from '../util/interfaces'

export class OpReferenceTypeObject implements IReferenceType, IJsonSerializable {

    // Properties

    private referenceObjectConstructor: { new(obj): IReferenceType }

    private _referenceObject: IReferenceType;
    public get referenceObject(): IReferenceType { return this._referenceObject };


    // Properties End


    // Ctor

    public constructor(opObj: any, objType: { new(obj): IReferenceType }) {
        this.referenceObjectConstructor = objType

        this.fromJSON(opObj)
    }

    // Ctor End


    // IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        if (this.referenceObject != null) {
            return this.referenceObject.getReferenceType()
        }

        return Enums.ReferenceType.None
    }

    public getReferenceKey(): number {
        if (this.referenceObject != null) {
            return this.referenceObject.getReferenceKey()
        }

        return null
    }

    public getReferenceValue(): any {
        if (this.referenceObject != null) {
            return this.referenceObject.getReferenceValue()
        }

        return null
    }

    // IReferenceType Implementation End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this._referenceObject = new this.referenceObjectConstructor(opObj.RO)
            }
            else {
                this._referenceObject = new this.referenceObjectConstructor(opObj.ReferenceObject)
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                RO: this.referenceObject,

                __IC: 1
            }
        } else {
            return {
                ReferenceObject: this.referenceObject
            }
        }
    }

    // IJsonSerializable Implementation End


    //#region getDescription

    public getDescription(): string {
        if (this.referenceObject != null) {
            return this.referenceObject.toString();
        }

        return null
    }

    //#endregion


    //#region toString

    public toString(): string {
        return this.getDescription()
    }

    //#endregion
}

